import { TokenStream, WithMeta } from '../lex';
import { buildEraQLAst } from '../eraql-ast/build-eraql-ast';
import { EraQlAst, ParseRes } from '../eraql-ast/ast';
import { ok, err } from 'neverthrow';
import { buildNode } from './Builder';
import { generateProgram } from './Generator';

export const MAX_LINE_WIDTH = 80;
export const INDENT_WIDTH = 2;

/**
 * Returns the input eraQL string as a formatted eraQL string.
 *
 * Propagates parse errors if inputEraQL is not valid.
 */
export function formatEraQL(inputEraQL: string): ParseRes<string> {
  const inputEraQLAst = parseToEraQLAst(inputEraQL);

  if (inputEraQLAst.isErr()) {
    return err(inputEraQLAst.error);
  }

  if (!inputEraQLAst.value) {
    return ok('');
  }

  const root = buildNode(inputEraQLAst.value);

  return ok(generateProgram(root));
}

/**
 * Derives an EraQLAst from eraQL.
 *
 * Propagates parse errors if inputEraQL is not valid.
 */
export function parseToEraQLAst(
  eraQL: string
): ParseRes<WithMeta<EraQlAst> | null> {
  const tokenStream = new TokenStream(eraQL);

  const eraQLAstWithMeta = buildEraQLAst(tokenStream, 0);

  if (eraQLAstWithMeta.isErr()) {
    return err(eraQLAstWithMeta.error);
  }

  if (!eraQLAstWithMeta.value) {
    return ok(null);
  }

  return ok(eraQLAstWithMeta.value);
}
